import React, { useEffect } from 'react';
import Apirest from '../../Content/Apirest';
import { PopulationData } from '../../Dashboard/Protocol/types';

import { useDispatch } from 'react-redux';
import { SET_POPULATION_DATA } from '../../store/data/types';

const DataProvider: React.FC = () => {

    let dispatch = useDispatch();
    let savePopulationsToStore = (populations: PopulationData[]) => {
        dispatch({
            type: SET_POPULATION_DATA,
            payload: populations
        });
    }

    useEffect(() => {
        Apirest.get_populations(savePopulationsToStore);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return null;
};

export default DataProvider;